// extracted by mini-css-extract-plugin
export default {"form-check":"Checkbox_form-check__wEwRp"};